export class ContactDataModel {
  id?: string;
  address?: string;
  company?: string;
  email?: string;
  person?: string;
  phone?: string;
  title?: string;
  website?: string;
  whatsapp?: string;
}

export class ContactData extends ContactDataModel {
  constructor(modelData: ContactDataModel) {
    super();

    (Object.keys(modelData) as (keyof ContactDataModel)[]).forEach((key) => {
      this[key] = modelData[key] ?? '';
    });
  }
}
